// Generate a downloadable .ics file for a booked appointment
export function downloadIcs({ title, description, location, date, time, durationMin = 30 }) {
  const [y, m, d] = date.split("-").map(Number);
  const [h, mm] = time.split(":").map(Number);
  // Ecuador is UTC-5 permanent, so convert local to UTC by adding 5h
  const start = new Date(Date.UTC(y, m - 1, d, h + 5, mm));
  const end = new Date(start.getTime() + durationMin * 60000);
  const fmt = (dt) => dt.toISOString().replace(/[-:]/g, "").split(".")[0] + "Z";
  const ics = [
    "BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//Agendik//ES", "CALSCALE:GREGORIAN",
    "BEGIN:VEVENT",
    `UID:${Date.now()}@agendik.io`,
    `DTSTAMP:${fmt(new Date())}`,
    `DTSTART:${fmt(start)}`,
    `DTEND:${fmt(end)}`,
    `SUMMARY:${title}`,
    `DESCRIPTION:${(description || "").replace(/\n/g, "\\n")}`,
    `LOCATION:${location || ""}`,
    "END:VEVENT", "END:VCALENDAR",
  ].join("\r\n");
  const blob = new Blob([ics], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "agendik-cita.ics";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
